// app/components/Header.tsx
'use client';

import { useEffect, useState } from 'react';
import { ENV } from '@/app/environment/environment';
import Link from 'next/link';

export default function Header() {
  const [showHeader, setShowHeader] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [animationClass, setAnimationClass] = useState('');

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY > lastScrollY && currentScrollY > 100) {
        // Scrolling down → Hide header
        setShowHeader(false);
        setAnimationClass('animate__fadeOutUp');
      } else {
        // Scrolling up → Show header
        setShowHeader(true);
        setAnimationClass('animate__fadeInDown');
      }

      setLastScrollY(currentScrollY);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollY]);

  return (
    <header
      className={`w-full fixed top-0 left-0 z-50 bg-white shadow-sm animate__animated ${
        animationClass
      } ${!showHeader ? 'pointer-events-none' : ''}`}
    >
      <div className="max-w-7xl mx-auto px-4 py-4 flex items-center justify-between">
        <Link href="/" className="text-xl font-semibold text-blue-600">
          <img
            src={`${ENV.bucket}/images/logo.png`}
            alt="logo"
            width="200px"
            style={{ borderRadius: '40px 0px' }}
          />
        </Link>
        <nav className="space-x-6 hidden md:flex">
          <Link href="#services" className="hover:text-blue-400 transition">Nos services</Link>
          <Link href="#cars" className="hover:text-blue-400 transition">Nos véhicules</Link>
          <Link href="#contact" className="hover:text-blue-400 transition">Contact</Link>
        </nav>
        <Link
          href="/booking"
          className="text-black px-4 py-2 rounded hover:bg-blue-700 transition text-sm"
        >
          Mon compte
        </Link>
      </div>
    </header>
  );
}
